import LeadActivity from './LeadActivity.component';

export default LeadActivity;
